import React from 'react'
import {Marker} from "react-google-maps"
import {database} from '../firebase'
import logook from '../assets/bg_green_car2.png'
import logodisconnect from '../assets/bg_red_car.png'
import logostandstill from '../assets/bg_yellow_car.png'

export default class RacerMarker extends React.Component {

    activeTimeout = 2 * 60 * 1000

    constructor(props) {
        super(props)
        this.state = {
            active: props.data.timeStamp.timeStamp > (new Date().getTime() - this.activeTimeout),
            no: "N/A"
        }
    }

    unsubscribe() {
        if (!(this.ref === null || this.ref === undefined)) {
            this.ref.off('value', this.listener)
            this.ref = null
            this.setState({})
        }
        this.unsubscribeUser()
    }

    clearTimers() {
        if (!(this.timeoutTimer === null || this.timeoutTimer === undefined)) {
            clearTimeout(this.timeoutTimer)
        }
    }

    restartTimers(activeTime) {
        this.clearTimers()

        const timeoutTime = (this.props.data.timeStamp.timeStamp - new Date().getTime()) + activeTime

        this.timeoutTimer = setTimeout(() => {
            this.setState({
                active: false
            })
        }, timeoutTime)
    }


    subscribeUser(uid) {
        this.unsubscribeUser()
        if (uid !== null && uid !== undefined) {
            this.userRef = database.ref('users/' + uid + "/id")
            this.userListener = this.userRef.on('value', data => {
                let identifier = data.val()
                this.setState({
                    no: (identifier && identifier.length > 0 && identifier) || 'N/A'
                })

            })
        }

    }

    unsubscribeUser() {
        if (!(this.userRef === null || this.userRef === undefined)) {
            this.userRef.off('value', this.userListener)
            this.userRef = null
        }
    }

    /*createIcon (active, speed, heading) {
      return {
        path: 'm 178.471,107.469 c -0.036,0.001 -0.15,0.018 -0.24,0.02 -0.878,0.019 -3.998,0.094 -5.7,0.48 -1.903,0.431 -3.806,1.018 -5.48,2.02 -2.505,1.5 -4.617,3.641 -6.56,5.82 -1.622,1.818 -2.862,3.944 -4.2,5.98 -0.538,0.819 -1.232,1.584 -1.52,2.52 -0.04,0.129 -0.093,0.245 -0.12,0.38 -31.257,0.088 -62.513,0.31 -93.76,1.02 -18.762,0.627 -37.167,10.052 -47.44,25.98 -4.402,5.134 -7.214,11.198 -8.48,17.76 -7.318,19.753 -4.191,41.284 -4.86,61.9 -0.621,16.44 2.831,32.975 10.28,47.6 8.66,13.65 21.606,25.827 38.16,28.3 23.191,4.821 47.076,2.084 70.58,2.88 11.854,-0.026 23.706,-0.018 35.56,-0.02 0.02,0.085 0.055,0.158 0.08,0.24 0.288,0.936 0.982,1.701 1.52,2.52 1.338,2.036 2.578,4.162 4.2,5.98 1.943,2.179 4.055,4.32 6.56,5.82 1.674,1.003 3.577,1.589 5.48,2.02 1.702,0.385 4.822,0.461 5.7,0.48 0.395,0.081 0.82,0.011 1.1,-0.2 0.28,-0.211 0.368,-0.419 0.44,-0.9 0.072,-0.481 -10e-4,-0.689 -0.32,-1.9 -0.319,-1.211 -1.082,-3.32 -1.9,-5.24 -0.818,-1.92 -2.176,-4.557 -3.08,-6.22 -0.578,-1.064 -1.048,-1.868 -1.5,-2.6 15.421,0.007 30.838,0.007 46.26,0.02 0.054,0.071 0.111,0.148 0.18,0.22 0.356,0.375 0.873,0.872 1.86,1.22 0.987,0.348 1.037,0.25 4.04,0.4 3.003,0.15 10.612,0.097 12.84,-0.04 2.228,-0.137 2.625,-0.172 3.72,-0.6 0.884,-0.346 1.544,-0.512 1.68,-1.18 23.496,0.006 47.005,-0.021 70.5,-0.12 0.864,0.293 1.059,0.217 3.92,0.36 3.003,0.15 10.632,0.097 12.86,-0.04 1.837,-0.113 2.436,-0.167 3.2,-0.42 19.412,-0.121 38.829,-0.305 58.24,-0.58 13.574,0.032 27.064,-8.429 31.62,-21.48 11.638,-28.71 11.428,-60.541 10.24,-91.04 -1.52,-19.914 -4.089,-40.865 -14.88,-58.06 -9.668,-13.695 -28.301,-14.1 -43.48,-14.04 -14.294,-0.15 -28.584,-0.208 -42.88,-0.24 -0.486,-0.064 -1.078,-0.12 -2.06,-0.18 -2.228,-0.137 -9.857,-0.19 -12.86,-0.04 -1.971,0.098 -2.633,0.098 -3.16,0.18 -18.306,-0.005 -36.613,0.039 -54.92,0.04 -5.439,0.029 -10.881,0.042 -16.32,0.06 -0.114,-0.706 -0.796,-0.867 -1.7,-1.22 -1.095,-0.428 -1.492,-0.463 -3.72,-0.6 -2.228,-0.137 -9.837,-0.19 -12.84,-0.04 -3.003,0.15 -3.053,0.052 -4.04,0.4 -0.987,0.348 -1.504,0.845 -1.86,1.22 -0.089,0.094 -0.177,0.187 -0.24,0.28 -15.421,0.02 -30.839,0.039 -46.26,0.06 0.471,-0.758 0.955,-1.587 1.56,-2.7 0.904,-1.664 2.262,-4.299 3.08,-6.22 0.818,-1.92 1.581,-4.029 1.9,-5.24 0.319,-1.211 0.392,-1.419 0.32,-1.9 -0.072,-0.481 -0.16,-0.689 -0.44,-0.9 -0.191,-0.144 -0.452,-0.21 -0.72,-0.22 -0.046,-0.002 -0.094,-0.002 -0.14,0 z m 52.58,17.08 c 0.569,-0.006 1.216,-0.006 1.84,0.02 -0.887,0.002 -1.773,-0.002 -2.66,0 0.282,-0.011 0.572,-0.017 0.82,-0.02 z m 161.62,7.32 c 3.984,-0.1 8.475,0.497 10.9,1.74 5.937,3.043 9.497,7.731 10.88,14.34 0.451,2.157 1.527,5.292 2.38,6.98 2.538,5.022 4.874,12.282 4.66,14.46 l -0.2,2.02 -1.98,-1.86 c -1.088,-1.02 -2.95,-3.953 -4.12,-6.52 -6.772,-14.861 -15.816,-23.517 -29.6,-28.36 -1.199,-0.421 -1.19,-0.468 -0.06,-1.3 1.258,-0.926 4.041,-1.422 7.14,-1.5 z m -214.34,1.26 c 1.289,-0.008 2.762,-0.003 4.4,0 10.918,0.021 29.102,0.262 48.16,0.66 l 13.6,0.28 5.3,8.32 c 2.911,4.567 5.377,8.74 5.48,9.28 0.185,0.969 0.136,0.967 -4.1,0.9 -2.361,-0.037 -8.515,-0.213 -13.66,-0.4 -14.533,-0.528 -36.943,-2.857 -51.1,-5.3 l -5.66,-0.96 -1.82,-2.84 c -1.002,-1.555 -2.866,-4.275 -4.14,-6.06 -1.274,-1.785 -2.387,-3.433 -2.48,-3.66 -0.047,-0.114 2.154,-0.196 6.02,-0.22 z m -127.58,0.46 c 1.039,0 2.219,-0.006 3.56,0 14.446,0.06 17.025,1.169 11.5,4.9 -3.192,2.156 -23.743,14.638 -32.06,19.48 -7.072,4.117 -9.857,6.488 -13.02,11.08 -1.273,1.848 -3.207,3.772 -4.32,4.3 -2.067,0.981 -5.292,1.268 -6.02,0.54 -0.226,-0.226 -0.42,-2.035 -0.42,-4.02 0,-3.856 1.171,-6.737 5.4,-13.4 3.48,-5.483 10.249,-13.165 14.26,-16.18 2.052,-1.542 6.01,-3.7 8.8,-4.78 4.407,-1.706 5.044,-1.92 12.32,-1.92 z m 217.5,0.82 c 1.649,-0.004 4.244,0.059 8.26,0.16 33.707,0.848 55.631,1.593 55.9,1.88 0.451,0.48 1.7,8.213 1.7,10.54 0,3.626 0.283,3.523 -12.22,4.18 -8.366,0.44 -40.073,1.428 -47.62,1.48 -0.734,0.005 -1.541,-1.452 -4.66,-8.4 -2.074,-4.619 -3.916,-8.752 -4.08,-9.18 -0.177,-0.463 -0.028,-0.654 2.72,-0.66 z m 84.34,4.84 c 0.728,-0.024 1.629,0.029 2.78,0.12 4.51,0.359 15.212,1.876 15.8,2.24 1.263,0.781 -5.239,3.088 -13.2,4.7 -5.925,1.2 -6.614,1.27 -8.08,0.68 -1.362,-0.548 -1.632,-2.195 -0.78,-4.76 0.724,-2.18 1.297,-2.909 3.48,-2.98 z m -238.72,3.74 c 1.925,0 55.013,11.673 64.22,14.12 6.208,1.65 12.08855,2.74127 19.81455,5.79727 16.97835,1.31951 14.84722,109.39128 -0.61,109.83 -22.98,8.949 -22.28855,5.94573 -50.18455,11.89273 -15.566,3.318 -29.535,6.317 -31.04,6.66 -2.204,0.502 -3.188,-0.271 -5.08,-4 -2.909,-5.735 -9.306,-25.696 -11.14,-34.78 -4.045,-20.033 -3.727,-55.656 0.64,-73.22 4.072,-16.38 11.416,-36.3 13.38,-36.3 z m 285.2,6.3 c 3.395,-0.166 4.423,2.766 8.12,9.7 10.055,18.859 13.099,35.101 12.16,65 -0.737,23.458 -2.732,32.473 -10.86,49 -7.083,14.402 -7.268,14.5 -17.72,9.52 -4.738,-2.257 -11.808,-5.301 -15.7,-6.76 -3.892,-1.459 -7.08,-2.875 -7.08,-3.14 0,-0.265 1.93,-4.293 4.28,-8.96 7.376,-14.648 9.794,-26.292 9.72,-46.82 -0.075,-20.549 -2.245,-30.756 -9.68,-45.52 -2.46,-4.884 -4.293,-9.025 -4.08,-9.2 0.213,-0.175 7.532,-3.43 16.26,-7.24 7.88,-3.44 11.94,-5.451 14.58,-5.58 z m -387.22,110.9 c 0.488,-0.043 1.092,0.041 1.84,0.22 3.659,0.874 4.193,1.296 7.28,5.54 3.662,5.035 5.749,6.701 14.84,11.96 13.472,7.793 31.589,19.145 32.24,20.2 1.395,2.262 -0.265,2.64 -12.72,2.78 -10.284,0.115 -12.234,-0.022 -15.04,-1.04 -9.38,-3.403 -16.845,-9.753 -23.88,-20.32 -5.178,-7.777 -6.403,-10.62 -6.42,-14.86 -0.012,-3.107 0.395,-4.352 1.86,-4.48 z m 409.44,3.22 0.18,1.84 c 0.217,2.132 -2.37,10.221 -4.56,14.22 -0.818,1.493 -1.902,4.672 -2.4,7.06 -2.12,10.167 -9.973,16.474 -20.26,16.3 -2.053,-0.035 -4.573,-0.254 -5.6,-0.5 -1.027,-0.246 -2.402,-0.752 -3.06,-1.12 -1.119,-0.626 -1.075,-0.708 0.64,-1.4 7.987,-3.225 12.381,-5.899 16.6,-10.06 5.036,-4.966 8.203,-9.575 12.3,-17.94 1.556,-3.178 3.565,-6.377 4.48,-7.1 z m -147.92,18.66 8.72,0.1 c 10.585,0.12 31.399,0.849 42.66,1.48 6.71,0.376 8.359,0.591 8.8,1.16 0.75,0.967 0.671,4.788 -0.22,9.44 l -0.76,3.9 -1.96,0.3 c -1.899,0.287 -24.574,0.961 -51.92,1.54 -9.474,0.201 -13.399,0.148 -13.28,-0.18 0.093,-0.256 1.92,-4.352 4.06,-9.1 z m -25.76,0.18 c 4.695,-0.008 7.74,0.179 7.74,0.62 0,0.57 -9.584,16.057 -10.62,17.16 -0.511,0.543 -11.651,0.836 -60.18,1.56 l -12.7,0.2 1.78,-2.46 c 0.985,-1.351 2.976,-4.281 4.42,-6.5 1.602,-2.461 2.989,-4.117 3.54,-4.24 4.928,-1.102 23.755,-3.611 35.48,-4.74 10.337,-0.995 22.715,-1.587 30.54,-1.6 z m 104.58,5.28 c 1.809,0.025 4.377,0.466 7.88,1.26 8.774,1.988 13.206,3.948 10.28,4.56 -2.82,0.59 -11.111,1.606 -15.22,1.86 l -4.42,0.26 -0.88,-1.44 c -0.482,-0.793 -1.002,-2.208 -1.16,-3.14 -0.394,-2.334 0.505,-3.402 3.52,-3.36 z',
        fillColor: !active ? '#b80000' : (speed < 1 ? '#FEBB00' : '#32CD32'),
        rotation: heading + 90,
        fillOpacity: 1,
        anchor: new window.google.maps.Point(256, 256),
        scale: 0.075
      }

    }*/

    createIcon(active, speed) {
        return {
            url: !active ? logodisconnect : (speed < 1 ? logostandstill : logook),
            scaledSize: new window.google.maps.Size(22, 22),
            labelOrigin: new window.google.maps.Point(11, 11),
            anchor: new window.google.maps.Point(11, 11),
        }

    }

    componentDidMount() {
        this.subscribeUser(this.props.uid)
    }

    componentDidUpdate(prevProps, prevState) {


        if (this.props.data.lat !== prevProps.data.lat || this.props.data.lng !== prevProps.data.lng) {
            this.restartTimers(this.activeTimeout)
        }
        if (prevState.uid !== this.state.uid) {
            this.subscribeUser(this.state.uid)
        }
    }

    onMarkerClicked = () => {
        this.props.onMarkerClick(this.props.id, this.state.position)
    }

    componentWillUnmount() {
        this.unsubscribeUser()
        this.clearTimers()
    }

    render() {
        return (<Marker
            visible={true}
            label={{
                text: this.state.no,
                color: 'white',
                style: 'bold',
                fontSize: "10px"
            }}
            onClick={this.onMarkerClicked} key={'racermarker_' + this.props.id}
            icon={this.createIcon((!this.props.data.disconnected && this.state.active), this.props.data.speedMS)}
            position={{lat: this.props.data.lat, lng: this.props.data.lng}}
            />)
    }

}



// WEBPACK FOOTER //
// ./src/views/RacerMarker.js